import { IReviewAsset } from 'mod/review/interface'
import { IAsset } from 'mod/feature/interface'
import { isVideoUrl } from 'base/utils/file'
import { isImage, isVideo, IUploadListItem } from '@base/snippets/FormUploadImages'


// 评论图片列表转换
export const transReviewImagesToLightboxImages = (
    images: IReviewAsset[]
): IAsset[] => {
    const _images = images.map((image) => {
        const isVideo = isVideoUrl(image.link)
        return {
            picUrl: isVideo ? '' : image.link,
            cover: image.thumbLink, // 缩略图
            videoUrl: isVideo ? image.link : '',
        }
    });

    return _images
}


/**
 * 试用评论上传资源检查 最少5张图片 1个视频
 * @param fileList
 */
export const reviewUploadValidator = (
    fileList: IUploadListItem[]
): 'image' | 'video' | true => {
    if (!fileList) {
        return 'image';

    } else {
        if (fileList.find(file => file.status === 'uploading')) {
            return 'image';
        }
        const imagesFiles = fileList.filter(file => {
            return (isImage(file) && ['success', 'done'].includes(file.status as string))
        })
        if (imagesFiles.length < 5) {
            return 'image';
        }
        const videoFiles = fileList.filter(file => {
            return (isVideo(file) && ['success', 'done'].includes(file.status as string))
        })
        if (videoFiles.length < 1) {
            return 'video'
        }
    }
    return true;
}